import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ShippingDetailsTab from './Freight/ShippingDetailsTab';
import RoutingTab from './Freight/RoutingTab';
import ChargesTab from './Charges/ChargesTab';
import ProfitLossTab from './Charges/ProfileLossTab';

const Charges = () => {

        const [activeTab, setActiveTab] = useState('charges'); // Default to 'charges' tab
      
        const handleTabClick = (tab) => {
          setActiveTab(tab);
        };

    return (
        <>
            <div className="row-gap-2">
      <div className="d-flex justify-content-between">
        <ul className="nav nav-pills mb-3 custom-tabs gap-0" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'charges' ? 'active' : ''}`}
              type="button"
              onClick={() => handleTabClick('charges')}
              aria-selected={activeTab === 'charges'}
            >
              Charge
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'profitLoss' ? 'active' : ''}`}
              type="button"
              onClick={() => handleTabClick('profitLoss')}
              aria-selected={activeTab === 'profitLoss'}
            >
              Profit & Loss
            </button>
          </li>
        </ul>
        <div>Quotation No.:</div>
      </div>

      <div className="tab-content">
        {activeTab === 'charges' && (
          <div className="tab-pane fade show active" role="tabpanel">
            <ChargesTab />
          </div>
        )}
        {activeTab === 'profitLoss' && (
          <div className="tab-pane fade show active" role="tabpanel">
            <ProfitLossTab />
          </div>
        )}
      </div>
    </div>
        </>
    )
}

export default Charges